import React from "react";

import { useIntl } from "react-intl";

import { EntityTypeSupportingNotes } from "@mapmycustomers/shared/types/entity";
import { TextField } from "@mapmycustomers/ui";

import { getEntityTypeDisplayName } from "@app/util/ui";

interface Props {
  entityName: string;
  entityType: EntityTypeSupportingNotes;
}

const EntityLabel: React.FC<Props> = ({ entityName, entityType }) => {
  const intl = useIntl();

  return (
    <TextField
      defaultValue={entityName}
      disabled
      label={getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: false })}
    />
  );
};

export default EntityLabel;
